import { Clickable, H3, Markdown, P, PortableText, Small } from '@ahmdigital/ui';
import { isArray, isUndefined, map } from 'lodash/fp';
import React from 'react';

import styles from './styles.module.sass';

// @ts-expect-error - Automatic, Please fix when editing this file
const wrapDescription = (description) =>
  isArray(description) ? <PortableText source={description} /> : <Markdown>{description}</Markdown>;

export type TermsAndConditionsProps = {
  terms: {
    cta?: {
      icon: string;
      title: string;
      url: string;
    };
    descriptionRaw?: string | unknown[];
    footnote?: {
      linkId: string;
      reference: string;
    };
    title?: string | null;
  }[];
};

const TermsAndConditions = ({ terms }: TermsAndConditionsProps) => (
  <>
    {map(({ title, descriptionRaw, footnote, cta }) => {
      const hasCta = !isUndefined(cta);

      return (
        <React.Fragment key={title}>
          {title && (
            <H3 looksLike="small" variant="marginBottomSpacer11">
              {title}
            </H3>
          )}
          <P variant={hasCta ? 'marginBottomSpacer10' : 'marginBottomSpacer9'}>
            <Small>
              {footnote && (
                <div id={footnote.linkId} className={styles.footnotePrefix}>
                  {footnote.reference}
                </div>
              )}
              {wrapDescription(descriptionRaw)}
            </Small>
          </P>
          {hasCta && (
            <Clickable icon={{ name: cta.icon, size: 'small' }} to={cta.url} variant="marginBottomSpacer9">
              {cta.title}
            </Clickable>
          )}
        </React.Fragment>
      );
    }, terms)}
  </>
);

export default TermsAndConditions;
